export default __webpack_public_path__ + "static/media/rare6.48392c1e.png";